/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface InviteTeamMemberRequestBody
 */
export interface InviteTeamMemberRequestBody {
  /**
   * Unique identifier for the agreement.
   * @type string
   * @memberof InviteTeamMemberRequestBody
   */
  agreementId: string
  /**
   * The user's first name from the agreement invitation, used to create the MinistrySafe (MS) user profile.
   * @type string
   * @memberof InviteTeamMemberRequestBody
   */
  firstName?: string
  /**
   * The user's last name from the agreement invitation, used to create the MinistrySafe (MS) user profile
   * @type string
   * @memberof InviteTeamMemberRequestBody
   */
  lastName?: string
}

export function InviteTeamMemberRequestBodyFromJSON(
  json: any
): InviteTeamMemberRequestBody {
  return InviteTeamMemberRequestBodyFromJSONTyped(json, false)
}

export function InviteTeamMemberRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InviteTeamMemberRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    agreementId: json['agreementId'],
    firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
    lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
  }
}

export function InviteTeamMemberRequestBodyToJSON(
  value?: InviteTeamMemberRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    agreementId: value.agreementId,
    firstName: value.firstName,
    lastName: value.lastName,
  }
}
